import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(private messageService: NzMessageService) {}

  handleError(error: HttpErrorResponse) {
    this.messageService.error('Something went wrong!');
    return throwError(() => error);
  }
}
